<template>
  <div>
      {{dataCSV}}
  </div>
</template>

<script>

export default {
  props: {
    csv: {
      type: String
    }
  },

  data: () => ({
    dataCSV: ''
  }),

  created () {
    this.dataCSV = this.$route.params.csv
    // console.log('test', this.$route.params.csv)
  },

  computed: {
  },

  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stats/csvExport.vue